import React from 'react';
import style from "../pagination.module.scss"
import cn from "classnames";
const DefaultPaginationButton = ({ isPrev = false, isNext = false, currentPage, text, updatePage, isDisabled = false }) => {
  return (
    <li className="page-item">
      <a
        className={cn("page-link", style.pagination_button, {
          [style.pagination_arrow]: isPrev || isNext,
          [style.pagination_active]: text === currentPage,
          [style.pagination_disabled]: isDisabled
        })}
        href="#"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          updatePage(text)
          window.scrollTo({
            top: 0,
            behavior:'smooth'
          });
        }}
        aria-label={isPrev ? "Previous" : isNext? "Next" : "Page"}
      >
        { isPrev
          ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32" fill="none">
              <path d="M6.11513 11.2501C6.26071 11.4168 6.3335 11.5967 6.3335 11.7898C6.3335 11.983 6.26071 12.1629 6.11513 12.3296L2.9106 16L6.11513 19.6704C6.26071 19.8371 6.3335 20.017 6.3335 20.2102C6.3335 20.4033 6.26071 20.5832 6.11513 20.7499C5.96957 20.9166 5.81249 21 5.6439 21C5.4753 21 5.31822 20.9166 5.17266 20.7499L1.58327 16.6387C1.4932 16.5356 1.42905 16.4315 1.39084 16.3265C1.35261 16.2216 1.3335 16.1128 1.3335 16C1.3335 15.8872 1.35261 15.7784 1.39084 15.6735C1.42905 15.5685 1.4932 15.4644 1.58327 15.3613L5.17266 11.2501C5.31822 11.0834 5.4753 11 5.6439 11C5.81249 11 5.96957 11.0834 6.11513 11.2501Z" fill="#6D7885"/>
            </svg>
            )
          : isNext
            ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32" fill="none">
                <path d="M15.5519 20.7499C15.4063 20.5832 15.3335 20.4033 15.3335 20.2102C15.3335 20.017 15.4063 19.8371 15.5519 19.6704L18.7564 16L15.5519 12.3296C15.4063 12.1629 15.3335 11.983 15.3335 11.7898C15.3335 11.5967 15.4063 11.4168 15.5519 11.2501C15.6974 11.0834 15.8545 11 16.0231 11C16.1917 11 16.3488 11.0834 16.4943 11.2501L20.0837 15.3613C20.1738 15.4644 20.2379 15.5685 20.2762 15.6735C20.3144 15.7784 20.3335 15.8872 20.3335 16C20.3335 16.1128 20.3144 16.2216 20.2762 16.3265C20.2379 16.4315 20.1738 16.5356 20.0837 16.6387L16.4943 20.7499C16.3488 20.9166 16.1917 21 16.0231 21C15.8545 21 15.6974 20.9166 15.5519 20.7499Z" fill="#6D7885"/>
              </svg>
            )
            : (
              <>
                { text }
              </>
            )
        }
      </a>
    </li>
  );
};

export default DefaultPaginationButton;